// extracted by mini-css-extract-plugin
module.exports = {"listItem":"_13de1a2605d5977dbe66647974f6666b-less","addForm":"cc5e0df20638ad23f64530b3cc9ae30a-less"};